import React from 'react';
import { ThemeProvider } from '@emotion/react';
import { CssBaseline, StyledEngineProvider } from '@mui/material';
// import { SignIn } from 'panna-auth';

import './App.css';
import RootRouter from './routes';
import theme from './theme';

function App() {
  console.log('test deployment on 27-08-2024');
  return (
    <div className="App">
      {/* <SignIn /> */}
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RootRouter />
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default App;
